export const CARD_STACK_OFFSET: number = -130;
export const CARD_OFFSET_IN_STACK: number = -14;
export const MAX_OPENED_CARDS_IN_STACK: number = 25;
